import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=78780fc1&scoped=true&"
import script from "./ErrorView.vue?vue&type=script&lang=js&"
export * from "./ErrorView.vue?vue&type=script&lang=js&"
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=78780fc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78780fc1",
  null
  
)

export default component.exports